import {omit} from 'util/omitKey';

import {AnalyticsParameterConfigGraphQL} from '../../../../graphql-fragments/insights/__generated/AnalyticsParameterConfigGraphQL';
import {ParameterConfigSetting, TypesafeParameterTypeAndConfigSetting} from '../ParameterConfigSetting';
import {ParameterType, ParameterTypeAndConfigSetting} from '../ParameterTypes';
import getParameterType from './getParameterType';

export default function getParameterTypeAndConfigSetting(
  parameterConfig: AnalyticsParameterConfigGraphQL
): ParameterTypeAndConfigSetting {
  return {
    type: getParameterType(parameterConfig),
    configSetting: getConfigSetting(parameterConfig),
    // Safe to cast here because we get both type and configSetting from the same config
  } as ParameterTypeAndConfigSetting;
}

export function getTypesafeParameterTypeAndConfigSettings<T extends ParameterType>(
  parameterConfig: AnalyticsParameterConfigGraphQL
): TypesafeParameterTypeAndConfigSetting<T> {
  return {
    type: getParameterType(parameterConfig),
    configSetting: getConfigSetting(parameterConfig),
  } as TypesafeParameterTypeAndConfigSetting<T>;
}

function getConfigSetting(config: AnalyticsParameterConfigGraphQL): ParameterConfigSetting {
  return omit(config, '__typename', 'systemName', 'id');
}
